// import {MMKVLoader} from 'react-native-mmkv-storage';

class FastStorage {
  localStorage;

  constructor() {
    this.localStorage = window.localStorage;
  }

  getItem = async (key: string) => {
    const value = this.localStorage.getItem?.(key);
    return value ?? null;
  };

  setItem = async (key: string, value: string) => {
    this.localStorage.setItem?.(key, value);
  };

  removeItem = async (key: string) => {
    this.localStorage.removeItem?.(key);
  };

  clear = () => this.localStorage.clear?.();
}

export default new FastStorage();
